import * as THREE from "three";

// Вершинный шейдер
const vertexShader = `
  varying vec2 vUv;
  varying vec3 vWorldPosition;
  
  void main() {
    vUv = uv;
    vWorldPosition = (modelMatrix * vec4(position, 1.0)).xyz;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;

// Фрагментный шейдер
const fragmentShader = `
  uniform vec3 color1;
  uniform vec3 color2;
  uniform vec3 cameraPos;
  varying vec2 vUv;
  varying vec3 vWorldPosition;
  
  void main() {
    // Вычисляем расстояние от камеры до точки на поверхности
    float distance = length(cameraPos - vWorldPosition);
    
    // Нормализуем расстояние для создания градиента
    float normalizedDistance = smoothstep(0.0, 65.0, distance);
    
    // Смешиваем цвета на основе расстояния
    vec3 finalColor = mix(color1, color2, normalizedDistance);
    
    gl_FragColor = vec4(finalColor, 1.0);
  }
`;

class GradientMaterial extends THREE.ShaderMaterial {
  constructor() {
    super({
      vertexShader,
      fragmentShader,
      uniforms: {
        color1: { value: new THREE.Color("#d7f5da") }, // Нижний цвет
        color2: { value: new THREE.Color("#2da137") }, // Верхний цвет
        cameraPos: { value: new THREE.Vector3() },
      },
    });
  }

  // Метод для обновления позиции камеры
  updateCameraPosition(camera) {
    this.uniforms.cameraPos.value.copy(camera.position);
  }
}

export { GradientMaterial };
